<template>
    <div class="dict-tag">
        <template v-for="item in matched">
            <span v-if="!item.listClass || item.listClass === 'default'" :key="item.dictValue" :class="item.cssClass">{{ item.dictLabel }}</span>
            <el-tag
                v-else
                :key="item.dictValue"
                size="mini"
                effect="plain"
                :type="item.listClass === 'primary' ? '' : item.listClass"
                :class="item.cssClass"
            >{{ item.dictLabel }}</el-tag>
        </template>
    </div>
</template>

<script>
export default {
    name: "DictTag",
    props: {
        // 字典列表 this.dict.type.xxx
        options: {
            type: Array,
            default: () => []
        },
        // 字典值，支持数组或多值字符串（用 separator 分割）
        value: {
            type: [Number, String, Array],
            default: ""
        },
        separator: {
            type: String,
            default: ","
        }
    },
    computed: {
        values(){
            if (this.value === null || this.value === undefined || this.value === "") {
                return []
            }
            if (Array.isArray(this.value)) {
                return this.value.map(v => "" + v)
            }
            return String(this.value).split(this.separator)
        },
        matched(){
            return this.options.filter(item => this.values.includes("" + item.dictValue))
        }
    }
}
</script>

<style lang="scss" scoped>
.dict-tag{
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
}
</style>
